import webrtcSupport from './WebRTCSupport';
import utils from '../../utils';
import SignalClient from './SignalClient';
import WebRTC from './WebRTC';
import ctor from './ctor';
import attachMediaStream from './attachMediaStream';

const WildEmitter = utils.WildEmitter;

const MeetingCenter = function(opts) {
    const that = this;
    let signalClient;

    this.config = {
        debug: false,
        signalServer: 'wss://182.92.159.47:8484/signal',
        signalClient: null,
        autoConnect: false,
        localVideoEl: '',
        remoteVideosEl: '',
        enableDataChannels: true,
        autoRequestMedia: false,
        autoRemoveVideos: true,
        adjustPeerVolume: false,
        peerVolumeWhenSpeaking: 0.25,
        media: {
            video: true,
            audio: true
        },
        receiveMedia: {
            offerToReceiveAudio: 1,
            offerToReceiveVideo: 1
        },
        localVideo: {
            autoplay: true,
            mirror: true,
            muted: true
        }
    };

    ctor.call(this, "MeetingCenter", opts);

    // attach detected support for convenience
    this.capabilities = webrtcSupport;
    
    this.webrtc = new WebRTC(opts);

    if (this.config.signalClient === null) {
        signalClient = this.signalClient = new SignalClient(this.config);
    } else {
        signalClient = this.signalClient = this.config.signalClient;
    }
    
    signalClient.on('connect', function () {
        that.emit('connectionReady', signalClient.getSessionid());
        that.sessionReady = true;
        that.testReadiness();
    });

    signalClient.on('disconnect', function () {
        //console.debug('disconnect');
        that.sessionReady = false;
    });

    signalClient.on('message', function (message) {
        // message.from 为空，表示此消息是待发送消息。
        if (!message || !message.from) return;

        const peers = that.webrtc.getPeers(message.from, message.roomType);
        let peer;

        if (message.type === 'offer') {
            if (peers.length) {
                peers.forEach(function (p) {
                    if (p.sid == message.sid) peer = p;
                });
            }
            if (!peer) {
                peer = that.webrtc.createPeer({
                    id: message.from,
                    sid: message.sid,
                    type: message.roomType,
                    enableDataChannels: that.config.enableDataChannels && message.roomType !== 'screen',
                    sharemyscreen: message.roomType === 'screen' && !message.broadcaster,
                    broadcaster: message.roomType === 'screen' && !message.broadcaster ? that.signalClient.getSessionid() : null
                });
                that.emit('createdPeer', peer);
            }
            peer.handleMessage(message);
        }
        else if (message.type === 'control') {
            const d = message.payload;
            switch(d.cmd) {
                case 'mute':
                    that.mute();
                    break;
                case 'unmute':
                    that.unmute();
                    break;
                case 'kick': {
                    let room = that.room;
                    that.leaveRoom();
                    that.emit('kick', room);
                }
                    break;
                case 'deleteRoom': {
                    let room = that.room;
                    that.leaveRoom();
                    that.emit('deleteRoom', room);
                }
                    break;
            }
        }
        else if (peers.length) {
            peers.forEach(function (peer) {
                if (message.sid) {
                    if (peer.sid === message.sid) {
                        peer.handleMessage(message);
                    }
                } else {
                    peer.handleMessage(message);
                }
            });
        }
    });

    signalClient.on('remove', function (room) {
        if (room.id !== that.signalClient.getSessionid()) {
            that.webrtc.removePeers(room.id, room.type);
        }
    });

    signalClient.on('stunservers', function (args) {
        // resets/overrides the config
        that.webrtc.config.peerConnectionConfig.iceServers = args;
        that.emit('stunservers', args);
    });

    signalClient.on('turnservers', function (args) {
        // appends to the config
        that.webrtc.config.peerConnectionConfig.iceServers =
            that.webrtc.config.peerConnectionConfig.iceServers.concat(args);
        that.emit('turnservers', args);
    });
    
    [
        'pauseVideo', 'resumeVideo', 'pause',
        'resume', 'sendToAll', 'sendDirectlyToAll', 'getPeers'
    ].forEach(function (method) {
        that[method] = that.webrtc[method].bind(that.webrtc);
    });

    // proxy events from WebRTC
    this.webrtc.on('*', function () {
        that.emit.apply(that, arguments);
    });

    // check for readiness
    this.webrtc.on('localStream', function () {
        that.testReadiness();
    });

    this.webrtc.on('message', function (payload) {
        that.signalClient.emit('message', payload);
    });

    this.webrtc.on('peerStreamAdded', this.handlePeerStreamAdded.bind(this));
    this.webrtc.on('peerStreamRemoved', this.handlePeerStreamRemoved.bind(this));

    // echo cancellation attempts
    if (this.config.adjustPeerVolume) {
        this.webrtc.on('speaking', this.setVolumeForAll.bind(this, this.config.peerVolumeWhenSpeaking));
        this.webrtc.on('stoppedSpeaking', this.setVolumeForAll.bind(this, 1));
    }

    
    this.webrtc.on('iceFailed', function (/*peer*/) {
        // local ice failure
    });
    this.webrtc.on('connectivityError', function (/*peer*/) {
        // remote ice failure
    });


    // sending mute/unmute to all peers
    this.webrtc.on('audioOn', function () {
        that.webrtc.sendToAll('unmute', {name: 'audio'});
    });
    this.webrtc.on('audioOff', function () {
        that.webrtc.sendToAll('mute', {name: 'audio'});
    });
    this.webrtc.on('videoOn', function () {
        that.webrtc.sendToAll('unmute', {name: 'video'});
    });
    this.webrtc.on('videoOff', function () {
        that.webrtc.sendToAll('mute', {name: 'video'});
    });
    this.webrtc.on('channelMessage', function (peer, label, data) {
        if (data.type == 'volume') {
            that.emit('remoteVolumeChange', peer, data.volume);
        }
    });

    if (this.config.autoRequestMedia) this.startLocalVideo();
};

WildEmitter.mixin(MeetingCenter);

const pt = MeetingCenter.prototype;

pt.destroy = function() {
    this.stopLocalVideo();
    if (this.signalClient) {
        this.disconnect();
        delete this.signalClient;
    }
};

pt.connect = function() {
    return this.signalClient.connect();
};

pt.disconnect = function () {
    if (this.sessionReady) {
        this.leaveRoom();
    }
    this.sessionReady = false;
    this.signalClient.disconnect();
};

pt.createRoom = function (room, cb) {
    this.room = room;
    this.nick = this.webrtc.nick = room.nick;
    if (arguments.length === 2) {
        this.signalClient.emit('create', room, cb);
    } else {
        this.signalClient.emit('create', room);
    }
};

pt.joinRoom = function (room, cb) {
    var that = this;
    this.room = room;
    this.nick = this.webrtc.nick = room.nick;
    this.signalClient.emit('join', room, function (err, roomDescription) {
        console.debug('join CB', err, roomDescription);
        if (err) {
            that.emit('error', err);
        }
        else {
            var id,
                client,
                type,
                peer;
            for (id in roomDescription.clients) {
                client = roomDescription.clients[id];
                for (type in client) {
                    if (client[type]) {
                        peer = that.webrtc.createPeer({
                            id: id,
                            type: type,
                            enableDataChannels: that.config.enableDataChannels && type !== 'screen',
                            receiveMedia: {
                                offerToReceiveAudio: type !== 'screen' && that.config.receiveMedia.offerToReceiveAudio ? 1 : 0,
                                offerToReceiveVideo: that.config.receiveMedia.offerToReceiveVideo
                            }
                        });
                        peer.nick = roomDescription.sessions[id].nick;
                        that.emit('createdPeer', peer);
                        peer.start();
                    }
                }
            }
        }

        if (cb) cb(err, roomDescription);
        that.emit('joinedRoom', room);
    });
};

pt.leaveRoom = function () {
    if (this.room) {
        this.signalClient.emit('leave');
        while (this.webrtc.peers.length) {
            this.webrtc.peers[0].end();
        }
        this.emit('leftRoom', this.room);
        this.room = undefined;
    }
};

pt.startLocalVideo = function () {
    var that = this;
    this.webrtc.start(this.config.media, function (err, stream) {
        if (err) {
            that.emit('localMediaError', err);
        } else {
            attachMediaStream(stream, that.getLocalVideoContainer(), that.config.localVideo);
        }
    });
};

pt.stopLocalVideo = function () {
    this.webrtc.stop();
};

pt.handlePeerStreamAdded = function (peer) {
    var that = this;
    var container = this.getRemoteVideoContainer();
    var video = attachMediaStream(peer.stream);

    // store video element as part of peer for easy removal
    peer.videoEl = video;
    video.id = this.getDomId(peer);

    if (container) {
        if (typeof (container.appendPeerStream) === 'function') {
            container.appendPeerStream(video, peer);
        }
        else {
            container.appendChild(video);
        }
    }

    this.emit('videoAdded', video, peer);

    // send our mute status to new peer if we're muted
    // currently called with a small delay because it arrives before
    // the video element is created otherwise (which happens after
    // the async setRemoteDescription-createAnswer)
    window.setTimeout(function () {
        if (!that.webrtc.isAudioEnabled()) {
            peer.send('mute', {name: 'audio'});
        }
        if (!that.webrtc.isVideoEnabled()) {
            peer.send('mute', {name: 'video'});
        }
    }, 250);
};

pt.handlePeerStreamRemoved = function (peer) {
    var container = this.getRemoteVideoContainer();
    var videoEl = peer.videoEl;
    if (this.config.autoRemoveVideos && container && videoEl) {
        if (typeof (container.removePeerStream) === 'function') {
            container.removePeerStream(videoEl, peer);
        }
        else {
            container.removeChild(videoEl);
        }
    }
    if (videoEl) this.emit('videoRemoved', videoEl, peer);
};

// set volume on video tag for all peers takse a value between 0 and 1
pt.setVolumeForAll = function (volume) {
    this.webrtc.peers.forEach(function (peer) {
        if (peer.videoEl) peer.videoEl.volume = volume;
    });
};

pt.testReadiness = function () {
    var that = this;
    if (this.sessionReady) {
        if (!this.config.media.video && !this.config.media.audio) {
            that.emit('readyToCall', that.signalClient.getSessionid());
        } else if (this.webrtc.localStreams.length > 0) {
            that.emit('readyToCall', that.signalClient.getSessionid());
        }
    }
};

pt.getEl = function (idOrEl) {
    if (typeof idOrEl === 'string') {
        return document.getElementById(idOrEl);
    } else {
        return idOrEl;
    }
};

pt.getLocalVideoContainer = function () {
    const el = this.getEl(this.config.localVideoEl);
    if (el && el.tagName === 'VIDEO') {
        el.oncontextmenu = function () { return false; };
        return el;
    } else if (el) {
        const video = document.createElement('video');
        video.oncontextmenu = function () { return false; };
        el.appendChild(video);
        return video;
    } else {
        return;
    }
};

pt.getRemoteVideoContainer = function () {
    return this.getEl(this.config.remoteVideosEl);
};

pt.getDomId = function (peer) {
    return [peer.id, peer.type, peer.broadcaster ? 'broadcasting' : 'incoming'].join('_');
};

pt.mute = function (opts) {
    if (opts && opts.target && this.sessionReady) {
        const sc = this.signalClient;
        sc.emit('message', {
            to: opts.target,
            sid: sc.getSessionid(),
            type: 'control',
            payload: {
                cmd: 'mute' //静音指令
            }
        });
    }
    else {
        this.webrtc.mute(opts);
    }
};

pt.unmute = function (opts) {
    if (opts && opts.target && this.sessionReady) {
        const sc = this.signalClient;
        sc.emit('message', {
            to: opts.target,
            sid: sc.getSessionid(),
            type: 'control',
            payload: {
                cmd: 'unmute' //取消静音指令
            }
        });
    }
    else {
        this.webrtc.unmute(opts);
    }
};

//踢出房间
pt.kick = function (opts) {
    if (opts && opts.target && this.sessionReady) {
        const sc = this.signalClient;
        sc.emit('message', {
            to: opts.target,
            sid: sc.getSessionid(),
            type: 'control',
            payload: {
                cmd: 'kick' //踢出房间
            }
        });
    }
};

//解散房间
pt.deleteRoom = function () {
    if (this.sessionReady) {
        const sc = this.signalClient;
        sc.emit('message', {
            to: 'all',
            sid: sc.getSessionid(),
            type: 'control',
            payload: {
                cmd: 'deleteRoom' //解散房间
            }
        });
    }
};

MeetingCenter.install = function(Vue, opts) {
    opts = opts || {};
    const cnf = opts.config;
    if (cnf) {
        pt.$appConfig = cnf;
    }
};

export default MeetingCenter;
